import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';
import { TooltipFactory } from '../../tooltip/js/tooltip-factory';

const enum Selectors {
	TooltipTrigger = '.js-m-table__tooltip-trigger',
}

@Component('Table')
export class Table extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public start() {
		TooltipFactory.initInlineTooltips(this.$ctx, Selectors.TooltipTrigger, 'm-tooltip--table');
	}

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}
}
